// Legacy slugs whose name differs from the page address. Any other slug is
// matched automatically against the page address (e.g. "/fax" → "fax",
// "/inventory-hub/hardware" → "inventory-hub-hardware", then "inventory-hub").
export const SLUG_PAGES = {
  "job-board": ["/jobs"],
  hardware: ["/inventory-hub/hardware"],
  inventory: ["/inventory-hub"],
  "network-keys": ["/inventory-hub/network-keys"],
  "did-master": ["/did-master", "/inventory-hub/did-master"],
  "number-orders": ["/number-orders", "/fax"],
};

export const slugForPath = (path) => path.replace(/^\/+|\/+$/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const pageForSlug = (slug) => (SLUG_PAGES[slug] || [`/${slug}`]).join(", ");

const matches = (path, page) => path === page || path.startsWith(`${page}/`);

// Order: exact page-address slug, then legacy aliases (most specific first), then parent pages.
export function slugCandidates(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const segs = path.split("/").filter(Boolean);
  const derived = segs.map((_, i) => slugForPath(segs.slice(0, segs.length - i).join("/")));
  const aliases = Object.entries(SLUG_PAGES)
    .flatMap(([slug, pages]) => pages.filter((p) => matches(path, p)).map((p) => [slug, p.length]))
    .sort((a, b) => b[1] - a[1])
    .map(([slug]) => slug);
  return [...new Set([...derived.slice(0, 1), ...aliases, ...derived.slice(1)])].filter(Boolean);
}
